<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogDetail"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >Fiche de Validation d'une demande de fonds</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 class="text-xs-right">
              <v-btn icons dark color="orange" @click="imprimerDemande()"
                >imprimer<v-icon right>print</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-card color="" class="mb-5" flat>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-alert :value="true" outline color="purple" icon="info">
                      Informations générales sur la demande
                    </v-alert>
                    <v-card flat>
                      <v-layout wrap>
                        <v-card-text>
                          <v-flex xs12>
                            <v-flex xs12 class="text-xs-left">
                              <!--HAUT-->
                              <v-layout row>
                                <v-flex xs6 class="mr-4">
                                  <!--COLONNE 1-->
                                  <v-layout row>
                                    <v-flex xs6
                                      >Identifiant de la demande</v-flex
                                    >
                                    <v-flex xs6 class="text-xs-right title">
                                      DMD-{{ demandeDetail.id }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Type de demande</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.typeDmd }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Demandeur</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.demandeur }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Enregistrée par: </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.userCreated }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row v-show="demandeDetail.projet">
                                    <v-flex xs6>Projet</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.projet }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="demandeDetail.projet"
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout row v-show="demandeDetail.chantier">
                                    <v-flex xs6>Chantier</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.chantier }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="demandeDetail.chantier"
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-show="demandeDetail.zoneCarburant"
                                  >
                                    <v-flex xs6>Zone</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.zoneCarburant }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="demandeDetail.zoneCarburant"
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                  >
                                    <v-flex xs6
                                      >Montant total (rénumération ouvrier
                                      chantier)
                                    </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{
                                        new Intl.NumberFormat().format(
                                          demandeDetail.renumTotal
                                        )
                                      }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                  >
                                    <v-flex xs6>Montant payé</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{
                                        new Intl.NumberFormat().format(
                                          demandeDetail.renumPaye
                                        )
                                      }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                  >
                                    <v-flex xs6>Montant restant</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{
                                        new Intl.NumberFormat().format(
                                          demandeDetail.renumRestant
                                        )
                                      }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    v-show="
                                      demandeDetail.typeDmd ==
                                        'RENUMERATION OUVRIER' && valider
                                    "
                                    class="mb-3"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-if="demandeDetail.photos[0] != ''"
                                  >
                                    <v-flex xs6>Pièce justificative</v-flex>
                                    <v-flex md6>
                                      <v-layout row>
                                        <v-flex xs12>
                                          <p></p>
                                        </v-flex>
                                        <v-flex xs12>
                                          <v-card>
                                            <a
                                              :href="demandeDetail.photos[0]"
                                              target="_blank"
                                            >
                                              <v-avatar
                                                class="mr-2"
                                                :tile="true"
                                                size="250px"
                                                height="250px"
                                                color="grey lighten-4"
                                              >
                                                <img v-if="demandeDetail.photos[0].substr(-3) == 'pdf'"
                                                  :src="logoPdf"
                                                  alt="avatar"
                                                />
                                                <img v-if="demandeDetail.photos[0].substr(-3) != 'pdf'"
                                                  :src="demandeDetail.photos[0]"
                                                  alt="avatar"
                                                />
                                              </v-avatar>
                                            </a>
                                            <!-- </span> -->
                                          </v-card>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs6 class="text-xs-left">
                                  <!--COLONNE 2-->

                                  <v-layout row>
                                    <v-flex xs6>Date de la demande</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.dateFormat }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Montant demandé </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.montantFormat }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex class="mb-3" xs6>Statut</v-flex>

                                    <v-flex xs6 class="text-xs-right title">
                                      <el-tag
                                        v-if="demandeDetail.statut == 0"
                                        type="danger"
                                      >
                                        {{ demandeDetail.libStatut }}</el-tag
                                      >
                                      <el-tag
                                        v-if="demandeDetail.statut == 1"
                                        >{{ demandeDetail.libStatut }}</el-tag
                                      >
                                      <el-tag
                                        v-if="demandeDetail.statut == 2"
                                        type="info"
                                        >{{ demandeDetail.libStatut }}</el-tag
                                      >
                                      <el-tag
                                        v-if="demandeDetail.statut == 3"
                                        type="success"
                                        >{{ demandeDetail.libStatut }}</el-tag
                                      >
                                      <el-tag
                                        v-if="demandeDetail.statut == 4"
                                        type="success"
                                        >{{ demandeDetail.libStatut }}</el-tag
                                      >
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Caisse </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ demandeDetail.caissePaie }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs2>Motif de la demande </v-flex>
                                    <v-flex xs10>
                                      <el-form class="demo-ruleForm">
                                        <el-form-item
                                          label=""
                                          style="width:100%"
                                        >
                                          <el-input
                                            :readonly="true"
                                            type="textarea"
                                            v-model="demandeDetail.motif"
                                          ></el-input>
                                        </el-form-item>
                                      </el-form>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout
                                    row
                                    v-if="demandeDetail.statut == 0"
                                  >
                                    <v-flex xs2>Motif du rejet </v-flex>
                                    <v-flex xs10>
                                      <el-form class="demo-ruleForm">
                                        <el-form-item
                                          label=""
                                          style="width:100%"
                                        >
                                          <el-input
                                            :readonly="true"
                                            type="textarea"
                                            v-model="demandeDetail.motifRefus"
                                          ></el-input>
                                        </el-form-item>
                                      </el-form>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>

                              <v-layout
                                row
                                v-show="
                                  demandeDetail.carteCarburant ||
                                    demandeDetail.carte
                                "
                              >
                                <v-flex xs12>
                                  <v-card>
                                    <v-flex xs12 class="mb-2">
                                      <v-alert
                                        :value="true"
                                        outline
                                        color="purple"
                                        icon="info"
                                      >
                                        Informations Carte
                                      </v-alert>
                                    </v-flex>
                                    <v-layout row>
                                      <el-table
                                        :data="recharge"
                                        style="width: 100%"
                                      >
                                        <el-table-column
                                          prop="identifiant"
                                          label="identifiant"
                                          sortable
                                        >
                                        </el-table-column>
                                        <el-table-column
                                          prop="montant"
                                          label="Solde de la carte (Fcfa)"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                          prop="fournisseur"
                                          label="Fournisseur"
                                        >
                                        </el-table-column>
                                      </el-table>
                                    </v-layout>
                                    <br />
                                  </v-card>
                                </v-flex>
                              </v-layout>

                              <!--DETAIL BUDGETAIRE-->
                              <v-layout v-show="valider">
                                <!--TABLEAU BUDGET MENSUEL DEMANDE DE FONDS-->
                                <v-flex xs12 class="mt-2">
                                  <v-alert
                                    :value="true"
                                    outline
                                    color="primary"
                                    class="mb-4"
                                    icon="info"
                                    >Détail du budget mensuel et total validé
                                    (Pour ce type de demande)
                                  </v-alert>
                                  <el-table
                                    border
                                    highlight-current-row
                                    :header-row-style="headerRowStyle"
                                    :data="demandeDetail.listeDmdBudget"
                                    style="width: 100%"
                                  >
                                    <el-table-column
                                      align="center"
                                      prop="libelle"
                                      label="DESIGNATION"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      align="center"
                                      sortable
                                      prop="periode"
                                      label="PERIODE"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      align="center"
                                      prop="budgetTotal"
                                      label="BUDGET VALIDE"
                                    >
                                      <template slot-scope="scope">
                                        {{
                                          new Intl.NumberFormat().format(
                                            scope.row.budgetTotal
                                          )
                                        }}
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      prop="mntFactureValide"
                                      label="FACTURE DEJA VALIDE"
                                    >
                                      <template slot-scope="scope">
                                        {{
                                          new Intl.NumberFormat().format(
                                            scope.row.mntFactureValide
                                          )
                                        }}
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      prop="ecartBudget"
                                      label="ECART BUDGET-FACTURE DEJA VALIDEE"
                                      sortable
                                    >
                                      <template slot-scope="prop">
                                        <v-chip label outline color="primary">{{
                                          new Intl.NumberFormat().format(
                                            prop.row.ecartBudget
                                          )
                                        }}</v-chip>
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      prop=""
                                      label="ETAT BUDGET (si la facture est validée)"
                                      sortable
                                    >
                                      <template slot-scope="prop">
                                        <el-tag
                                          :type="
                                            prop.row.ecartBudget >=
                                            demandeDetail.montant
                                              ? 'success'
                                              : 'danger'
                                          "
                                          disable-transitions
                                        >
                                          <span
                                            v-if="
                                              prop.row.ecartBudget >=
                                                demandeDetail.montant
                                            "
                                            >Dans le budget</span
                                          >
                                          <span v-else>Hors budget</span>
                                        </el-tag>
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </v-flex>
                                <!--TABLEAU BUDGET MENSUEL DEMANDE DE FONDS-->
                              </v-layout>
                            </v-flex>
                          </v-flex>
                        </v-card-text>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>

      <v-tooltip top>
        <v-btn
          v-show="valider || logistique == true"
          class="mb-5"
          style="margin-right: 100px"
          absolute
          slot="activator"
          dark
          fab
          large
          bottom
          right
          color="red"
          @click="dialogConfirmRefus = true"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <span>Refuser la demande</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn
          v-show="valider || logistique == true"
          class="mb-5 ml-5"
          absolute
          slot="activator"
          dark
          fab
          large
          bottom
          right
          color="green"
          @click="dialogConfirm = true"
        >
          <v-icon>done</v-icon>
        </v-btn>
        <span>Valider la demande</span>
      </v-tooltip>
    </v-dialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
        <v-card>
          <v-card-title class="headline"
            >Validation d'une demande de fonds</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 class="mb-2">
                <el-alert
                  title="Voulez vous Refuser cette demande de fonds ?"
                  :closable="false"
                  show-icon
                  type="error"
                >
                </el-alert>
              </v-flex>
              <v-flex xs12>
                <p class="grey--text font-weight-thin body-1">
                  DEMANDE DE FONDS
                </p>
                <p class="black--text .font-weight-regular subheading">
                  DMD-{{ demandeDetail.id }}
                </p>
                <p class="red--text .font-weight-regular subheading">
                  MONTANT: {{ demandeDetail.montantFormat }} FCFA
                </p>
              </v-flex>
              <v-flex xs12>
                <el-form
                  id="formRefus"
                  :rules="ruleFormRefus"
                  ref="refFormRefust"
                  label-position="top"
                  :inline="true"
                  :model="formRefus"
                  class="demo-form-inline"
                >
                  <v-flex xs12>
                    <el-form-item
                      style="width:100%"
                      label="Commentaire"
                      prop="rapportRefus"
                    >
                      <el-input
                        style="width:100%"
                        type="textarea"
                        :rows="6"
                        placeholder="Pourquoi voulez-vous refuser ?"
                        v-model="formRefus.rapport"
                      ></el-input>
                    </el-form-item>
                  </v-flex>
                </el-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              dark
              @click.native="dialogConfirmRefus = false"
              >Annuler</v-btn
            >
            <v-btn color="red darken-1" dark @click.native="SubmitRefusDevis()"
              >Refuser</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <CoolLightBox :items="items" :index="index" @close="index = null">
    </CoolLightBox>
    <!-- CONFIRMATION VALIDATION -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogConfirm" persistent max-width="650">
        <v-card>
          <v-card-title class="headline"
            >Validation d'une demande de fonds</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 class="mb-2">
                <el-alert
                  title="Voulez vous valider cette demande de fond ?"
                  :closable="false"
                  show-icon
                  type="success"
                >
                </el-alert>
              </v-flex>
              <v-flex xs12>
                <p class="grey--text font-weight-thin body-1">
                  DEMANDE DE FONDS
                </p>
                <p class="black--text .font-weight-regular subheading">
                  DMD-{{ demandeDetail.id }}
                </p>
                <p class="red--text .font-weight-regular subheading">
                  MONTANT: {{ demandeDetail.montantFormat }} FCFA
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              dark
              @click.native="dialogConfirm = false"
              >Annuler</v-btn
            >
            <v-btn
              color="green darken-1"
              dark
              @click.native="SubmitValideDevis()"
              >Confirmer</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "ModalValidationDmdFond",
  props: ["show", "demandeDetail", "valider", "logistique", "type"],
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      tableProduit: [],
      totalTTC: 0,
      formRapport: {},
      dialogVisible: false,
      dialogImageUrl: "",
      logoPdf: '/static/pdf.png',
      recharge: [],
      items: [],
      index: null,
      dialogConfirmRefus: false,
      dialogConfirm: false,
      formRefus: {},
      ruleFormRefus: {
        rapportRefus: [{ required: true, message: "Veuillez saisir" }]
      }
    };
  },
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetail = newValue;
    
      if (newValue == true) {
        let url =
          this.domaine + "demandeFond/recharge/" + this.demandeDetail.id;
        this.$http.get(url).then(response => {
          this.recharge = response.body.recharge;
        });
      }
    },
    demandeDetail: function(newValue, oldvalue) {
    //   console.log("ok la");
    }
  },
  computed() {
    // console.log("rjerje", this.demandeDetail);
  },
  methods: {
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    imprimerDemande() {
    //   console.log("Id demande");
    //   console.log(this.demandeDetail);
      let url =
        this.domaine +
        "demandeFond/imprimerPDF/demande/" +
        this.demandeDetail.id;
      window.open(url);
    },

    showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },

    successNotif(mess = "") {
      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },

    closeDialog() {
      this.$emit("close", this.demandeDetail.id, "demandeFond");
    },

    SubmitValideDevis() {
      this.loading = true;
      let url = "";
      if (this.logistique) {
        url = this.domaine + "demandeFond/logistique/validation";
      } else {
        url = this.domaine + "demandeFond/validation";
      }
      let data = new FormData();
      data.append("idDemande", this.demandeDetail.id);
      data.append("idUser", this.user.id);
      data.append("reponse", 2); //accepte
      data.append("rapport", "");
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          this.successNotif(response.body.message);
          this.dialogConfirm = false;
          this.closeDialog();
        },
        errResp => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors de la validation de la demande"
          );
        }
      );
    },
    SubmitRefusDevis() {
      this.loading = true;
      let url = "";
      if (this.logistique) {
        url = this.domaine + "demandeFond/logistique/validation";
      } else {
        url = this.domaine + "demandeFond/validation";
      }
      let data = new FormData();
      data.append("idDemande", this.demandeDetail.id);
      data.append("idUser", this.user.id);
      data.append("reponse", 0); //refuser
      data.append("rapport", this.formRefus.rapport);

      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          this.successNotif(response.body.message);
          this.dialogConfirmRefus = false;
          this.closeDialog();
        },
        errResp => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du refus de la demande"
          );
        }
      );
    }
  },
  mounted() {
    // console.log("demandeDetail", this.demandeDetail);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationDmdFond.vue